import { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const QueryParamsContext = createContext();

export const QueryParamsProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const formatDate = (date) => date.toISOString().split("T")[0];

  const getDefaultDateRange = () => {
    const today = new Date();
    const prior = new Date();
    prior.setDate(today.getDate() - 30);
    return {
      start_date: formatDate(prior),
      end_date: formatDate(today),
    };
  };

  const initialParams = new URLSearchParams(location.search);
  const [dateRange, setDateRangeState] = useState(() => {
    const savedStart = sessionStorage.getItem("saved_start_date");
    const savedEnd = sessionStorage.getItem("saved_end_date");

    return {
      start_date: initialParams.get("start_date") || savedStart || getDefaultDateRange().start_date,
      end_date: initialParams.get("end_date") || savedEnd || getDefaultDateRange().end_date,
    };
  });

  const [queryString, setQueryString] = useState("");

  useEffect(() => {
    if (location.pathname.startsWith("/login") || location.pathname==="/" || location.pathname==="/settings" 
      || location.pathname==="/register" || location.pathname==="/set-password" ||location.pathname==="/signup"
       || location.pathname==="/pricing" || location.pathname==="/onboarding" || location.pathname==="/login/*") return; 
    if (dateRange.start_date && dateRange.end_date) {
      sessionStorage.setItem("saved_start_date", dateRange.start_date);
      sessionStorage.setItem("saved_end_date", dateRange.end_date);

      const newQuery = `?start_date=${dateRange.start_date}&end_date=${dateRange.end_date}`;
      setQueryString(newQuery);

      const current = new URLSearchParams(location.search);
      if (
        current.get("start_date") !== dateRange.start_date ||
        current.get("end_date") !== dateRange.end_date
      ) {
        navigate(newQuery, { replace: true });
      }
    }
  }, [dateRange, navigate, location.search]);

  return (
    <QueryParamsContext.Provider value={{ queryString, dateRange, setDateRange: setDateRangeState }}>
      {children}
    </QueryParamsContext.Provider>
  );
};

export const useQueryParams = () => useContext(QueryParamsContext);